// useEventBus.ts
import { useEffect, useCallback } from 'react';

export function useEventBus<T = unknown>(eventName: string, handler?: (data: T) => void) {
  // 메시지 보내기
  const emit = useCallback((data: T) => {
    const event = new CustomEvent(eventName, { detail: data });
    window.dispatchEvent(event);
  }, [eventName]);

  // 구독 등록
  useEffect(() => {
    if (!handler) return;

    const listener = (event: Event) => {
      const customEvent = event as CustomEvent<T>;
      handler(customEvent.detail);
    };

    window.addEventListener(eventName, listener);

    return () => {
      window.removeEventListener(eventName, listener);
    };
  }, [eventName, handler]);

  return { emit };
}
